"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjudicationSliceOf = adjudicationSliceOf;
exports.normalizedCellValueOf = normalizedCellValueOf;
exports.sameCellValue = sameCellValue;
exports.signalKeyColumnOf = signalKeyColumnOf;
const consensus_types_1 = require("../../../../Consensus/consensus.types");
const general_package_slices_1 = require("../../../../Consensus/general-slices/general-package-slices");
const slice_key_1 = require("../../../../Consensus/slice-key");
const SIGNAL_KEY_COLUMN_BY_SLICE = {
    [slice_key_1.SliceKey.Pinout]: 'signalName',
    [slice_key_1.SliceKey.SignalAttributes]: 'signalName',
    [slice_key_1.SliceKey.FloatingBehaviour]: 'signalName',
};
const CACHE_KEY_SEPARATOR = '\x1F';
const sliceCache = new Map();
function adjudicationSliceOf(input, paramUnitsResolver) {
    const cacheKey = [input.sliceKey, input.sigmaModelType].join(CACHE_KEY_SEPARATOR);
    const cached = paramUnitsResolver === undefined ? sliceCache.get(cacheKey) : undefined;
    if (cached !== undefined) {
        return cached;
    }
    const slice = (0, general_package_slices_1.createGeneralReviewSlices)(paramUnitsResolver, {
        includeModesSlice: true,
        sigmaModelType: input.sigmaModelType,
        includePinAssignmentsSlice: true,
    }).find((candidate) => candidate.sliceKey === input.sliceKey);
    if (slice === undefined) {
        throw new Error(`No general-plane slice defines '${input.sliceKey}', so its values cannot be normalized.`);
    }
    if (paramUnitsResolver === undefined) {
        sliceCache.set(cacheKey, slice);
    }
    return slice;
}
function normalizedCellValueOf(raw, anchor, input, slice) {
    if (raw === null || raw === undefined) {
        return null;
    }
    const column = anchor.kind === consensus_types_1.AnchorKind.Field ? anchor.column : '';
    const row = input.rows.find((candidate) => candidate.rowKey === anchor.rowKey)?.values;
    const normalized = slice.normalizeValue(column, raw, row);
    return normalized === '' ? null : normalized;
}
function sameCellValue(input, anchor, left, right) {
    const slice = adjudicationSliceOf(input);
    return normalizedCellValueOf(left, anchor, input, slice) === normalizedCellValueOf(right, anchor, input, slice);
}
function signalKeyColumnOf(sliceKey) {
    return SIGNAL_KEY_COLUMN_BY_SLICE[sliceKey] ?? null;
}
//# sourceMappingURL=adjudication-slice.js.map